import Ajax from '@/lib/ajax'
export default {
  // 获取列表
  getList(
    pageSize: number,
    currentPage: number,
    keyWord?: string
  ) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
    }
    if(keyWord) {
      params['KeyWord'] = keyWord
    }

    return Ajax.get('/api/MarketingManagement/couponPackage', {
      params: params,
    })
  },
  /**
   * 创建券包
   * @param data
   */
  addCoupon(data: any) {
    return Ajax.post(`/api/MarketingManagement/couponPackage`, data)
  },
  /**
   * 更新券包
   * @param id
   * @param data
   */
  updateCoupon(id: string, data: any) {
    return Ajax.put(`/api/MarketingManagement/couponPackage/${id}`, data)
  },
  /**
   * 更新券包
   * @param id
   * @param data
   */
  getDetail(id: string) {
    return Ajax.get(`/api/MarketingManagement/couponPackage/${id}`)
  },
  // 获取券包订单
  getCouponpackOrderList(pageSize: number, currentPage: number, OrderStatus: number, keyWord?: string) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
    }
    if(keyWord) {
      params['KeyWord'] = keyWord
    }
    if(OrderStatus != null) {
      params['OrderStatus'] = OrderStatus
    }
    return Ajax.get(`/api/MarketingManagement/couponPackageOrder`, {
      params
    })
  },
  // 获取订单详情
  getCouponOrderDetail(id: string) {
    return Ajax.get(`/api/MarketingManagement/couponPackageOrder/${id}`)
  },
  // 导出订单
  exportExcel(pageSize: number, currentPage: number, OrderStatus: number, keyWord?: string) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
    }
    if(keyWord) {
      params['KeyWord'] = keyWord
    }
    if(OrderStatus != null) {
      params['OrderStatus'] = OrderStatus
    }
    return Ajax.get(`/api/MarketingManagement/couponPackageOrder`, {
      params
    })
  },
  // 取消订单
  cancelOrder(ids: any[]) {
    return Ajax.put(`/api/MarketingManagement/couponPackageOrder/Cancel`, ids)
  },
  /**
   * 获取订单操作日志
   * @param id
   */
  getOrderNote(id: string) {
    return Ajax.get(`/api/OrderManagement/OrderNote/all/${id}`)
  },
  /**
   * 获取券包报表
   */
  getCouponPackReport(
    currentPage: number,
    pageSize: number,
    Keyword?: string,
  ) {
    let params = {
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      MaxResultCount: pageSize,
    }
    if (Keyword) {
      params['Keyword'] = Keyword
    }
    // if (Begin) {
    //   params['Begin'] = Begin
    // }
    // if (End) {
    //   params['End'] = End
    // }
    // if (TenantId) {
    //   params['TenantId'] = TenantId
    // }
    // if (userLevel) {
    //   params['UserLevel'] = userLevel
    // }
    // if (shopType != null) {
    //   params['shopType'] = shopType
    // }
    // if (paymentMethod != null) {
    //   params['paymentMethod'] = paymentMethod
    // }
    return Ajax.get(`/api/MarketingManagement/couponPackageOrderReport`, {
      params,
    })
  },
  /**
   * 获取券包统计
   */
  getCouponpackSummary(
    currentPage: number,
    pageSize: number,
    orderNo?: string,
    // Begin?: string,
    // End?: string,
    // TenantId?: string,
    // shopType?: number,
    // userLevel?: string,
    // paymentMethod?: number
  ) {
    let params = {
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      MaxResultCount: pageSize,
    }
    if (orderNo) {
      params['Keyword'] = orderNo
    }
    // if (Begin) {
    //   params['Begin'] = Begin
    // }
    // if (End) {
    //   params['End'] = End
    // }
    // if (TenantId) {
    //   params['TenantId'] = TenantId
    // }
    
    // if (userLevel) {
    //   params['userLevel'] = userLevel
    // }
    // if (shopType != null) {
    //   params['shopType'] = shopType
    // }
    // if (paymentMethod != null) {
    //   params['paymentMethod'] = paymentMethod
    // }
    return Ajax.get(`/api/MarketingManagement/couponPackageOrderReport/Summary`, {
      params,
    })
  },
  // 导出券包统计
  exportCouponpackReport(
    orderNo?: string,
  ) {
    let params = {}
    if (orderNo) {
      params['Keyword'] = orderNo
    }
    // if (Begin) {
    //   params['Begin'] = Begin
    // }
    // if (End) {
    //   params['End'] = End
    // }
    // if (TenantId) {
    //   params['TenantId'] = TenantId
    // }
    
    // if (storeId) {
    //   params['storeId'] = storeId
    // }
    // if (paymentMethod) {
    //   params['paymentMethod'] = paymentMethod
    // }
    // return Ajax.get(`/api/Report/MallStatistics/ExportFile`, {
    return Ajax.get(`/api/MarketingManagement/couponPackageOrderReport/ExportFile`, {
      params,
      responseType: 'blob',
    })
  },
}